var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrapper"},[(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('p',[_vm._v("Chargement des données...")])]):(_vm.error)?_c('div',{staticClass:"error-container"},[_c('p',[_vm._v(_vm._s(_vm.error))])]):_c('canvas',{attrs:{"id":"chartFour"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }